import Badge, {
  type BadgeVariant,
} from "@/v2-backoffice-client/components/badge"
import {
  getScoreLevel,
  SCORE_LEVEL_LABELS,
  SCORE_TOOLTIP,
  type ScoreLevel,
} from "@/v2-backoffice-client/usage/usage.constants"

export type UsageScoreBadgeProps = {
  score: number | null | undefined
  /** Hide the band label and show only the number (dense contexts). */
  compact?: boolean
  className?: string
}

const SCORE_VARIANTS: Record<ScoreLevel, BadgeVariant> = {
  power: "positive-strong",
  healthy: "positive",
  cooling: "warning",
  dormant: "critical",
  new: "neutral",
}

// 0-100 engagement score rendered as "63 Healthy": the band label carries
// the meaning, the number the precision. Tinted pill per band (green /
// amber / red) so the color scale is monotone and readable in both themes.
function UsageScoreBadge(props: UsageScoreBadgeProps) {
  const { score, compact = false, className } = props
  const level = getScoreLevel(score)

  if (score == null) {
    return (
      <Badge
        className={className}
        tooltip="No engagement score yet — the user has no tracked activity."
      >
        —
      </Badge>
    )
  }

  return (
    <Badge
      className={className}
      variant={SCORE_VARIANTS[level]}
      tooltip={SCORE_TOOLTIP}
    >
      {score}
      {!compact && (
        <span className="font-normal">{SCORE_LEVEL_LABELS[level]}</span>
      )}
    </Badge>
  )
}

export default UsageScoreBadge
